import React, { useState } from 'react';
import { IoArrowBack } from 'react-icons/io5';
import './DqLLMTable.css';

function NestedDqLLMTable({ item, rowSelected, setRowSelected }) {
  const [metricType, setMetrixType] = useState('');

  return (
    <div style={{ margin: '8px' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <IoArrowBack size={40} onClick={() => setRowSelected(-1)} className="dqLLM-back-btn" />
        <span className="dqLLM-nexted-title">{item?.xAxis?.data[rowSelected]}</span>
      </div>
      <br />
      <div className="dsqi-row">
        {item?.series
          ?.sort((a, b) => a.name.localeCompare(b.name))
          ?.map((ele) => (
            <div
              className="single-card nestedDqLLMCard"
              key={ele}
              style={{
                backgroundColor: '#fbf3eb',
                boxShadow: `${metricType === ele.name ? '4px 2px 12px #707070' : ''}`,
              }}
              aria-hidden="true"
              onClick={(e) => setMetrixType(ele.name)}
            >
              <div className="single-card-heading">{ele.name}</div>
              <div className="single-card-value">
                {ele.data[rowSelected] === 0 ? 'NA' : `${ele.data[rowSelected]}%`}
              </div>
            </div>
          ))}
      </div>

      {metricType && (
        <div className="nestedDqLLMTable">
          Bad Records: 120
          <br />
          Good Records: 320
        </div>
      )}
    </div>
  );
}

export default NestedDqLLMTable;
